import React from "react"
import withStyles from "react-jss"
import { Link } from "."
import colors from "../data/colors"
import recipes from "../data/recipes"
import regionMapping from "../data/regions"
import { TRANSITION_DURATION } from "../data/globalStyles"
import { dishTooltipPositionMapping, tooltipWidth } from "../data/regions"
import { getKeyByValue } from "../utils/helper"

const styles = {
  container: {
    position: "absolute",
    transform: "translate(-50%,-50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "50vmin",
    height: "50vmin",
    maxWidth: "320px",
    maxHeight: "320px",
    transition: `opacity ${TRANSITION_DURATION}s ease-in-out`,
    "@media only screen and (max-width: 900px)": {
      width: "40vmin",
      height: "40vmin",
      maxWidth: "275px",
      maxHeight: "275px",
    },
  },
  content: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  region: {
    maxWidth: "12ch",
    padding: "0.3rem 0.6rem",
    margin: "0!important",
    fontSize:
      "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))!important",
    textAlign: "center",
    fontWeight: "600!important",
    border: `1px solid ${colors.black}`,
    color: `${colors.black}!important`,
    pointerEvents: "none",
    zIndex: 2,
  },
  dish: {
    position: "absolute",
    transform: "translate(-50%,-50%)",
    "@media  (min-width: 851px) and (max-width: 1000px)": {
      transform: "translate(-60%,-60%)",
    },
    "@media  (min-width: 451px) and (max-width: 850px)": {
      transform: "translate(-70%,-70%)",
    },
    "@media (max-width: 450px)": {
      transform: "translate(-80%,-80%)",
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    transition: `top ${TRANSITION_DURATION}s ease-in-out, left ${TRANSITION_DURATION}s ease-in-out`,
  },
  imgContainer: {
    border: "2px solid #3E4B59",
    borderRadius: "50%",
    width: "15vmin",
    height: "15vmin",
    maxWidth: "140px",
    maxHeight: "140px",
  },
  img: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
  },
  dishTitle: {
    fontFamily: "Jost!important",
    fontWeight: "400!important",
    lineHeight: 1.2,
    textDecoration: "none",
    color: "black",
    fontSize:
      "calc(12px + (15 - 12) * ((100vw - 300px) / (1600 - 300)))!important",
    padding: "0.1rem!important",
    background: `${colors.white}!important`,
    textAlign: "center!important",
    maxWidth: "14vmin!important",
    margin: "0.1rem!important",
  },
}

const DishesTooltip = ({ classes, data, activeRegion }) => {
  if (!data.region && !data.center) return
  const dishData = recipes[data.region]
  const positions = dishTooltipPositionMapping[data.region]
  const tooltipSize = tooltipWidth[data.region]
  const activeRegionNumber = getKeyByValue(regionMapping, data.region)
  const isActive = activeRegion === data.region
  const tabIndex = isActive ? 0 : -1
  return (
    <div
      className={classes.container}
      aria-label={`List of dishes in ${data.region}`}
      style={{
        left: data.center[0],
        top: data.center[1],
        opacity: isActive ? 1 : 0,
        pointerEvents: isActive ? "auto" : "none",
        ...tooltipSize,
      }}>
      <div className={classes.content}>
        <h2
          className={classes.region}
          style={{
            backgroundColor: colors[`${activeRegionNumber}Lighter`],
          }}>
          {data.region.toUpperCase()}
        </h2>
        {dishData.map((d, i) => (
          <div
            className={classes.dish}
            key={i}
            style={
              isActive
                ? positions[i]
                : {
                    top: "50%",
                    left: "50%",
                  }
            }>
            <Link href={d.url} tabIndex={tabIndex}>
              <div className={classes.imgContainer}>
                <img className={classes.img} src={d.img} alt={d.name} />
              </div>
              <p className={classes.dishTitle}>{d.name}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withStyles(styles)(DishesTooltip)
